import BoldSmallText from '@/components/BoldSmallText';
import RegularText from '@/components/RegularText';
import { Button, Icon, Tooltip } from '@shopify/polaris';
import { MinusIcon, PlusIcon } from '@shopify/polaris-icons';
import { LanguageItemStyled } from './styled';

interface IProps {
  name: string;
  estDeliveryDate: string;
  isSelected: boolean;
  onSelect: () => void;
  isAdded: boolean;
  onAction: () => void;
  isHasBottomBorder?: boolean;
}

const LanguageItem = ({ name, estDeliveryDate, isSelected, onSelect, isAdded, onAction, isHasBottomBorder }: IProps) => {
  return (
    <LanguageItemStyled
      className="d-flex align-center justify-between "
      isSelected={isSelected}
      isHasBottomBorder={!!isHasBottomBorder}
    >
      <div className="d-flex flex-column gap-4 w-full cursor-pointer item-content" onClick={onSelect}>
        <BoldSmallText>{name}</BoldSmallText>
        <RegularText>Estimate: {estDeliveryDate}</RegularText>
      </div>
      <Tooltip content={isAdded ? 'Remove from this language' : 'Add to this language'}>
        <Button
          icon={<Icon source={isAdded ? MinusIcon : PlusIcon} />}
          variant={isAdded ? undefined : 'primary'}
          onClick={onAction}
        ></Button>
      </Tooltip>
    </LanguageItemStyled>
  );
};

export default LanguageItem;
